const domRenderFunctions = {
    alertMessage: function (message) {
        var alertTemplate = '<div class="alert-success-message-big-text" style="display:none;">' +
            '<span class="update-icon">' +
            '<img src="/store1/users/resources/images/successicon.png">' +
            '</span>' +
            '<p class="success-text">' +
            '<span class="email-updated-text">' + message + ' <span class="alert-cross" id="alert-close" style="cursor: pointer !important;"><img src="/store1/users/resources/images/closeicon.png"></span></span>' +
            '</p>' +
            '<p id="customTabName"></p>' +
            '</div>';
        return alertTemplate;

    },renderError: function (fieldId, message) {
        fieldId.after('<label class="error injected_label tabindex=-1"><i class="errorFormat" tabindex=-1>' + message + '</i></label>');
        fieldId.css('border-color', '#e71316');
    },removeIdentifierError: function (identifier) {
        var errorLabel = $(identifier).next('label.injected_label');
        if (errorLabel.length > 0) {
            errorLabel[0].remove();
            $(identifier).css('border-color', '#B2B2B2');
            $('#errorHeaderr').hide();
        }
    },showErrorMessage: function (message,errorDivId) {
        var $warning = $('#errorHeader');
        var $warningMsg = $warning.find('.errorLabelRegForm');
        var $infoErrorDiv = $warning.find(errorDivId);
        $warning.show();
        $warningMsg.show();
        $infoErrorDiv.show();
        $warningMsg.text(message);
        $([document.documentElement, document.body]).animate({
            scrollTop: $infoErrorDiv.offset().top
        }, 100);
        
        setTimeout(function () {
            $warning.hide();
            $warningMsg.hide();
            $infoErrorDiv.hide();
            $warningMsg.hide();
        }, 10000);
    },hideErrorMessage: function (errorDivId) {
        var $warning = $('#errorHeader');
        var $infoErrorDiv = $warning.find(errorDivId);
        $infoErrorDiv.hide();
        $warning.hide();

    },alertErrorMessage: function (message) {
        var alertTemplate = '<div class="alert-failure-message-big-text" style="display:none;">' +
            '<span class="update-icon">' +
            '<img src="/store1/users/resources/images/errorInfoIcon.png">' +
            '</span>' +
            '<p class="failure-text">' +
            '<span class="email-updated-text">' + message +
            '</p>' +
            '<p id="customTabName"></p>' +
            '</div>';
        return alertTemplate;

    },
    escapeHtml: function (toSafe) {
        return toSafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }
};